import React, { FC } from 'react';
import DynamicField from '../domain/DynamicField';
import { alphabeticallyOrderedFields } from '../utils';
import FormDynamicField from './FormDynamicField';

export interface FormDynamicFieldsProps {
  fields: DynamicField[];
  namePrefix?: string;
  onSubmit?: (option: string, field: DynamicField, name: string) => void;
}

const FormDynamicFields: FC<FormDynamicFieldsProps> = ({
  namePrefix,
  fields,
  onSubmit,
}) => {
  return (
    <>
      {alphabeticallyOrderedFields(fields).map((field) => (
        <FormDynamicField
          field={field}
          namePrefix={namePrefix}
          onSubmit={onSubmit}
        />
      ))}
    </>
  );
};

export default FormDynamicFields;
